export default __webpack_public_path__ + "static/media/ic-instagram-dark.2ffcac18.svg";